"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SortDef_1 = require("../SortDef");

var SortDefConverter_1 = require("./SortDefConverter");
/**
 * Default implementation of {@link SortDefConverter}.
 *
 * @author Radek Beran
 */


var SortDefConverterImpl =
/*#__PURE__*/
function (_SortDefConverter_1$S) {
  _inherits(SortDefConverterImpl, _SortDefConverter_1$S);

  function SortDefConverterImpl() {
    _classCallCheck(this, SortDefConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SortDefConverterImpl).apply(this, arguments));
  }

  _createClass(SortDefConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SortDef_1.SortDef(source.fieldName, source.desc);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {};
      document = Object.assign(document, {
        fieldName: source.fieldName,
        desc: source.desc
      });
      return document;
    }
  }]);

  return SortDefConverterImpl;
}(SortDefConverter_1.SortDefConverter);

exports.SortDefConverterImpl = SortDefConverterImpl;